'use strict';
/* ==========================================================================
   core-local/hooks.js — "50% Off, Then 50% Off = Free?": this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js), from the notebook
             pack's palette (docs/NOTEBOOK.md §2): Ms. Rivera = red pen (her pen does the marking), Jay = ballpoint ink.
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   Puppets: the cast (DESIGN.md §3) — rivera (rivera, rivera_point), jay (jay, jay_point). Fine-liner line art from
            the assets agent (assets/img/<name>.png, assets/ASSETS.md Round 2). Facing (Puppet.NATIVE): jay and jay_point
            face the front (0, never mirrored; jay_point's finger is up, not a direction); rivera_point points to the
            viewer's RIGHT (+1): she stands on the right of the page facing -1, so the art is mirrored and her point aims
            left, at Jay and the working. rivera (front, a receipt in one hand) is +1 too, so BOTH her poses mirror
            together in the video and her head doesn't jump sides when the pose swaps (title/map draw her facing +1:
            unmirrored). The pointing arm widens the PNG, so the body is off-centre in the
            point poses: levels/video.js shifts those poses (POSE_DX) so the body stays put when the pose swaps.
   ========================================================================== */
window.LessonHooks = {
  speakers: { rivera: { name: 'Ms. Rivera', color: '#d23f33' }, jay: { name: 'Jay', color: '#1d2b4f' } },
  captions({ script }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    return { text, who };
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; the first/default pose per character) */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  P.POSES.rivera = { rivera: 'rivera', point: 'rivera_point', rivera_point: 'rivera_point' };
  P.POSES.jay = { jay: 'jay', point: 'jay_point', jay_point: 'jay_point' };
  P.DEFAULT.rivera = 'rivera'; P.DEFAULT.jay = 'jay';
  Object.assign(P.NATIVE, { rivera: 1, rivera_point: 1, jay: 0, jay_point: 0 });
})();
